import * as joda from "@js-joda/core";
import { Source } from "trader.ts/types/source";
import { textbox } from "trader.ts/ui.common";
import { Field, Parsing, syncRawAndParsing } from "trader.ts/ui.forms";

export function dateBoxNullable(opts: {
  initialVal?: joda.LocalDate | null;
  label?: string;
  style?: string;
  class?: string;
  id?: string;
  onChange?: (d: joda.LocalDate | null) => void;
}): Promise<Field<joda.LocalDate | null>> {
  const rawS = new Source(opts.initialVal ? opts.initialVal.toString() : "");

  const parsingS: Source<Parsing<joda.LocalDate | null>> = new Source(
    opts.initialVal
      ? { tag: "parsed", parsed: opts.initialVal }
      : {
          tag: "parsed",
          parsed: null,
        },
  );

  function parse(raw: string): {
    tag: "parsed";
    parsed: joda.LocalDate | null;
  } {
    try {
      const parsed = joda.LocalDate.parse(raw);
      return { tag: "parsed", parsed };
    } catch {
      return { tag: "parsed", parsed: null };
    }
  }

  if (opts.onChange) {
    parsingS.observe((s) =>
      s.tag === "parsed" ? opts.onChange!(s.parsed) : {},
    );
  }
  syncRawAndParsing({
    rawS,
    parsingS,
    parse,
    parsedToRaw: (r) => {
      return r ? r.toString() : "";
    },
  });

  function render() {
    return textbox({
      ...opts,
      required: true,
      source: rawS,
      type: "date",
    });
  }

  return Promise.resolve({
    s: parsingS,
    cleanup: () => {},
    render,
  });
}
